import { useEffect, useRef } from "react";

/**
 * Scrolls the table body container to top and brings the table region into view
 * when `scrollResetKey` changes (e.g. pagination page or rows-per-page limit).
 * Skips the first run so initial page load does not jump scroll position.
 */
export const useTableScrollReset = (scrollResetKey: string | number | undefined) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const skipInitialScrollReset = useRef(true);

  useEffect(() => {
    if (scrollResetKey === undefined) return;
    if (skipInitialScrollReset.current) {
      skipInitialScrollReset.current = false;
      return;
    }

    scrollContainerRef.current?.scrollTo({ top: 0, left: 0 });
    rootRef.current?.scrollIntoView({ block: "start", behavior: "auto" });
  }, [scrollResetKey]);

  return { rootRef, scrollContainerRef };
};
